export interface BlueprintFormState {
  name: string;
  tags: string[];
  rateTable: string;
  paymentTerm: string;
  executiveSummary: string;
  solutionSummary: string;
}

export const defaultBlueprintFormState: BlueprintFormState = {
  name: "",
  tags: [],
  rateTable: "",
  paymentTerm: "",
  executiveSummary: "",
  solutionSummary: "",
};
